module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "char"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHARACTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BLIND")]), _vm._v("’ "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")]), _vm._v(", a singer")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")]), _vm._v(", the Greek general, King of Ithaca")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ATHENA")]), _vm._v(", a goddess, also disguised as "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CAPTAIN MENTES, A SHEPHERD")]), _vm._v(", etc.")]), _vm._v(" "), _c('p', {
    staticClass: "fmh1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Ithaca")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")]), _vm._v(", wife of Odysseus")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")]), _vm._v(", son of Odysseus")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")]), _vm._v(", his old nurse")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")]), _vm._v(", a suitor to Penelope")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYMACHUS, AMPHINOMUS, CTESIPPUS, LEODES")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("POLYBUS")]), _vm._v(", suitors")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MELANTHO")]), _vm._v(", a maid")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EUMAEUS")]), _vm._v(", an old swineherd")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ARNAEUS")]), _vm._v(", a lout")]), _vm._v(" "), _c('p', {
    staticClass: "fmh1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Pylos")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")]), _vm._v(", King of Pylos")]), _vm._v(" "), _c('p', {
    staticClass: "fmh1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sparta")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("MENELAUS")]), _vm._v(", King of Sparta")]), _vm._v(" "), _c('p', {
    staticClass: "uls"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HELEN")]), _vm._v(", his wife")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PROTEUS")]), _vm._v(", the Old Man of the Sea")]), _vm._v(" "), _c('p', {
    staticClass: "fmh1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Ship")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYLOCHUS")]), _vm._v(", Odysseus’ lieutenant")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELPENOR")]), _vm._v(", the helmsman")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("STRATIS, COSTA, STAVROS")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TASSO")]), _vm._v(", Odysseus’ crew")]), _vm._v(" "), _c('p', {
    staticClass: "fmh1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Scheria")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")]), _vm._v(", a princess")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALCINOUS")]), _vm._v(", her father, King of the Phaeacians")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANEMONE")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHLOE")]), _vm._v(", Phaeacian girls")]), _vm._v(" "), _c('p', {
    staticClass: "fmh1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Island of the Cyclops")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("A PHILOSOPHER")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TWO PATROLMEN")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("RAM")]), _vm._v(", a manservant")]), _vm._v(" "), _c('p', {
    staticClass: "fmh1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Island of Calypso")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")]), _vm._v(", a witch")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("REVELLERS")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CELEBRANTS")])]), _vm._v(" "), _c('p', {
    staticClass: "fmh1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Underworld")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")]), _vm._v(", Odysseus’ mother")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TIRESIAS")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AGAMEMNON, ACHILLES, THERSITES")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AJAX")]), _vm._v(", the ghosts of Troy")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("Suitors, Attendants, Maids, Sailors, Mermaids, Courtiers, Athletes, etc.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bae9ea8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/characters.vue
// module id = 72
// module chunks = 0